import script from "./FontPicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./FontPicker.vue?vue&type=script&setup=true&lang=ts"

import "./FontPicker.vue?vue&type=style&index=0&id=7e6d1adb&lang=css"

const __exports__ = script;

export default __exports__